export default __webpack_public_path__ + "static/media/692.777f4352.png";